export default __webpack_public_path__ + "static/media/SG.a9f3c5bd.svg";